module.exports = __webpack_public_path__ + "img/coding-practice.64ef9f1a.svg";